module.exports = __webpack_public_path__ + "img/Submit.a1ebf97d.svg";